module.exports = __webpack_public_path__ + "img/ireland.d3255f94.png";